import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { THEMES, useTheme } from '@/lib/theme';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { t } = useTranslation('nav');
  const { theme, toggle } = useTheme();
  const isDark = theme === THEMES.dark;
  const label = isDark ? t('theme.switch_to_light') : t('theme.switch_to_dark');

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={[
        'inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors duration-fast ease-out-quart hover:bg-muted hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isDark ? (
        <Sun className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Moon className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
